export const authorityBodyEnum = {
  0: "IA",
  1: "MPFA",
  2: "SFC",
};
